import clsx from "clsx";

function HistorySidebar() {
  return (
    <div className={clsx("history-sidebar")}>
      <div className="point">
        <p className="scale-anim">
          <span className="outside-circle" />
        </p>
        <span className="inside-circle" />
      </div>
    </div>
  );
}

export default HistorySidebar;
